import { useCallback } from 'react'
import { AnalyticsEventProperties } from 'core/analytics/analytics-types'
import { HomepageEvent } from 'core/constants/homepage-analytics'
import { trackHomepageEvent } from './track-homepage-event'

export const useHomepageAnalytics = () => {
  return useCallback((event: HomepageEvent, properties?: AnalyticsEventProperties) => {
    trackHomepageEvent(event, properties)
  }, [])
}
